import React, { PropsWithChildren } from 'react';
import { ISonURL } from '../../../types/IUrl';
import { getHexColor, ICategory } from '../../../types/ICategory';
import { PagePackStates } from '../../../types/api/PagePackState';
import { PageLinkExtendedInfo } from '../../../_lib/components/PageLinkExtendedInfo';
import { PageType } from '../../../types/api/PageType';
import { PageConnectionDetails } from '../../../_lib/components/PageConnectionDetails/PageConnectionDetails';

export type Assignment = {
  pageLink: ISonURL;
  role?: string;
  categories?: ICategory[];
  packState?: PagePackStates;
  pageType?: PageType;
};

export function PageToPageAssignmentCard({
  children,
  pageLink,
  role,
  categories,
  packState,
  pageType,
}: PropsWithChildren<Assignment>) {
  const categoryColour = getHexColor(categories);

  return (
    <div
      className="page-to-page-block__assignment-card"
      style={categoryColour ? { borderLeftColor: categoryColour } : undefined}
    >
      <div className="page-to-page-block__link-content">
        <div className="page-to-page-block__link">
          <PageLinkExtendedInfo
            pageLink={pageLink}
            highlightText
            stateIndicatorStatus={packState === 'onlyDraftVersion' ? 'red' : undefined}
          />
        </div>
        <PageConnectionDetails pageType={pageType} roles={role} categories={categories} />
      </div>
      {children}
    </div>
  );
}
